module.exports = __webpack_public_path__ + "static/media/PNG.0795958a.svg";